
import { useState, useEffect } from 'react';
import { Paper, Box, Typography, Tabs, Tab, useTheme } from '@mui/material';

export default function LeaderBoard({ correctDigits, startTime }) {
  const [tab, setTab] = useState(0);
  const [leaderboard, setLeaderboard] = useState([]);
  const theme = useTheme();

  useEffect(() => {
    // Load leaderboard from localStorage
    const savedLeaderboard = localStorage.getItem('piChallengeLeaderboard');
    if (savedLeaderboard) {
      setLeaderboard(JSON.parse(savedLeaderboard));
    }
  }, []);

  useEffect(() => {
    if (correctDigits > 0 && startTime) {
      const endTime = Date.now();
      const duration = ((endTime - startTime) / 1000).toFixed(2);
      
      // Update leaderboard
      const newLeaderboard = [...leaderboard];
      newLeaderboard.push({
        name: localStorage.getItem('lastPlayerName') || 'Anonymous',
        digits: correctDigits,
        time: duration,
        date: new Date().toISOString()
      });
      
      // Sort by digits (descending) and time (ascending)
      newLeaderboard.sort((a, b) => {
        if (b.digits !== a.digits) return b.digits - a.digits;
        return parseFloat(a.time) - parseFloat(b.time);
      });
      
      // Keep only top 10
      const topScores = newLeaderboard.slice(0, 10);
      setLeaderboard(topScores);
      
      // Save to localStorage
      localStorage.setItem('piChallengeLeaderboard', JSON.stringify(topScores));
    }
  }, [correctDigits, startTime]);

  const getFilteredLeaderboard = () => {
    if (tab === 0) return leaderboard; // All time
    
    // Today's scores
    const today = new Date().toISOString().split('T')[0];
    return leaderboard.filter(entry => 
      entry.date.split('T')[0] === today
    );
  };

  return (
    <Paper 
      sx={{ 
        p: 2, 
        flex: 1,
        minWidth: 300,
        backgroundColor: theme.palette.primary.main,
        color: 'white'
      }}
    >
      <Typography variant="h6" gutterBottom>
        Leaderboard
      </Typography>
      
      <Tabs 
        value={tab} 
        onChange={(e, newValue) => setTab(newValue)}
        sx={{ 
          borderBottom: 1, 
          borderColor: 'divider',
          '& .MuiTab-root': { color: 'white' }
        }}
      >
        <Tab label="All Time" />
        <Tab label="Today" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {getFilteredLeaderboard().map((entry, index) => (
          <Box 
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              p: 1,
              borderBottom: `1px solid ${theme.palette.divider}`
            }}
          >
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Typography>{index + 1}</Typography>
              <Typography>{entry.name}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Typography>{entry.digits} digits</Typography>
              <Typography>{entry.time}s</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
